
import React from 'react';
import { sitemapData } from '@/data/sitemapData';
import CalculatorCategorySection from './CalculatorCategorySection';
import MathCalculatorsSection from './MathCalculatorsSection';
import BenefitsSection from './BenefitsSection';

const CalculatorCategoriesContainer = () => {
  return (
    <div className="max-w-6xl mx-auto rounded-lg p-8 border-0 shadow-none bg-transparent">
      <h2 className="text-2xl font-bold mb-8">Calculator Categories</h2>
      
      {/* Finance Calculators */}
      <CalculatorCategorySection 
        title="Finance Calculators"
        viewAllLink="/special"
        items={sitemapData[0].items}
      />
      
      {/* Math & Statistics */}
      <MathCalculatorsSection />
      
      {/* Health & Fitness */}
      <CalculatorCategorySection 
        title="Health & Fitness"
        viewAllLink="/special"
        items={sitemapData[1].items}
      />
      
      {/* Time & Date Calculators */}
      <CalculatorCategorySection 
        title="Time & Date Calculators"
        viewAllLink="/calculators"
        items={sitemapData[2].items}
      />
      
      {/* Unit Converters */}
      <CalculatorCategorySection 
        title="Unit Converters"
        viewAllLink="/converters"
        items={sitemapData[3].items}
      />

      {/* Benefits Section */}
      <BenefitsSection />
    </div>
  );
};

export default CalculatorCategoriesContainer;
